import React from 'react';

const PRIORITY_LABELS = {
  speed: 'Geschwindigkeit',
  accuracy: 'Genauigkeit',
  consistency: 'Konsistenz',
  cost: 'Kostenreduktion',
};

const FREQUENCY_LABELS = {
  daily: 'Täglich',
  weekly: 'Wöchentlich',
  monthly: 'Monatlich',
  quarterly: 'Quartalsweise',
  yearly: 'Jährlich',
  'ad-hoc': 'Bei Bedarf',
  'Täglich': 'Täglich',
  'Wöchentlich': 'Wöchentlich',
  'Monatlich': 'Monatlich',
  'Quartalsweise': 'Quartalsweise',
  'Jährlich': 'Jährlich',
  'Bei Bedarf': 'Bei Bedarf',
};

const COMPLEXITY_LABELS = {
  low: 'Niedrig',
  medium: 'Mittel',
  high: 'Hoch',
  niedrig: 'Niedrig',
  mittel: 'Mittel',
  hoch: 'Hoch',
  Niedrig: 'Niedrig',
  Mittel: 'Mittel',
  Hoch: 'Hoch',
};

export default function SummaryPhase({ summary, onConfirm, onEdit, isGenerating, error }) {
  if (!summary) return null;

  const { jtbd, inputs, outputs, priority, frequency, painPoints, context } = summary;

  return (
    <div className="summary-container">
      <div className="summary-window">
        {/* Header */}
        <div className="summary-header">
          <h2>So habe ich deine Aufgabe verstanden</h2>
          <p className="summary-subtitle">Prüfe ob alles stimmt, bevor wir den Prozess generieren.</p>
        </div>

        {/* JTBD Card */}
        {jtbd && (
          <div className="summary-card jtbd-card">
            <div className="card-label">Deine Aufgabe</div>
            <div className="jtbd-statement">
              <span className="jtbd-verb">{jtbd.verb}</span>
              <span className="jtbd-object">{jtbd.object}</span>
              <span className="jtbd-context">{jtbd.context}</span>
            </div>
          </div>
        )}

        {/* Inputs + Outputs Grid — simple teal bullet dots, no emoji icons (6.3.4) */}
        <div className="summary-grid">
          {/* Inputs */}
          {inputs && inputs.length > 0 && (
            <div className="summary-card">
              <div className="card-label">Eingaben</div>
              <div className="io-list">
                {inputs.map((inp, i) => (
                  <div key={i} className="io-item">
                    <span className="io-bullet" />
                    <div className="io-details">
                      <span className="io-name">{inp.name}</span>
                      <span className="io-source">Quelle: {inp.source}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Outputs */}
          {outputs && outputs.length > 0 && (
            <div className="summary-card">
              <div className="card-label">Ergebnisse</div>
              <div className="io-list">
                {outputs.map((out, i) => (
                  <div key={i} className="io-item">
                    <span className="io-bullet" />
                    <div className="io-details">
                      <span className="io-name">{out.name}</span>
                      <span className="io-source">An: {out.destination}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Meta row: Priority + Frequency + Complexity — all German (6.3.3) */}
        <div className="summary-meta-row">
          {priority && (
            <div className="meta-chip">
              <span className="meta-chip-label">Priorität</span>
              <span className="meta-chip-value">{PRIORITY_LABELS[priority] || priority}</span>
            </div>
          )}
          {frequency && (
            <div className="meta-chip">
              <span className="meta-chip-label">Häufigkeit</span>
              <span className="meta-chip-value">{FREQUENCY_LABELS[frequency] || frequency}</span>
            </div>
          )}
          {context?.complexity && (
            <div className="meta-chip">
              <span className="meta-chip-label">Komplexität</span>
              <span className={`meta-chip-value complexity-${context.complexity}`}>
                {COMPLEXITY_LABELS[context.complexity] || context.complexity}
              </span>
            </div>
          )}
        </div>

        {/* Pain Points — simple teal bullets, no lightning emoji (6.3.5) */}
        {painPoints && painPoints.length > 0 && (
          <div className="summary-card pain-card">
            <div className="card-label">Schmerzpunkte</div>
            <div className="pain-list">
              {painPoints.map((pain, i) => (
                <div key={i} className="pain-item">
                  <span className="pain-bullet-dot" />
                  <span>{pain}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Context: Stakeholders */}
        {context?.stakeholders && context.stakeholders.length > 0 && (
          <div className="summary-card">
            <div className="card-label">Beteiligte</div>
            <div className="stakeholder-tags">
              {context.stakeholders.map((s, i) => (
                <span key={i} className="stakeholder-tag">{s}</span>
              ))}
            </div>
          </div>
        )}

        {error && !isGenerating && (
          <div className="error-message" style={{ marginTop: '1rem' }}>{error}</div>
        )}

        {/* Action Buttons — "Prozess generieren" only, no prefix, no arrow (6.3.6) */}
        <div className="summary-actions">
          <button className="btn btn-summary-secondary" onClick={onEdit} disabled={isGenerating}>
            Anpassen
          </button>
          <button className="btn btn-summary-primary" onClick={onConfirm} disabled={isGenerating}>
            {isGenerating ? 'Wird generiert...' : error ? 'Erneut versuchen' : 'Prozess generieren'}
          </button>
        </div>
      </div>
    </div>
  );
}
